import UsersModal from '../users-modal/users-modal';
import TooltipComp from '../tooltip-comp/tooltip-comp';
import type { TooltipPosition } from '../tooltip-comp/tooltip-comp';
import styles from './other-users-comp.module.scss';
import ModalPortalComp from '../modal-portal-comp/modal-portal-comp';

type Props = {
  users: Array<any>;
  textStyle?: any;
  hookStyle?: any;
  hookClassName?: string;
  tooltipPosition?: TooltipPosition;
  modalHeader: string;
  hideTooltip?: boolean;
  hideModal?: boolean;
  getData?: () => void;
  getUserLink: (userId: string) => string;
  visibleInTooltip?: number;
  visibleUsers?: number;
  firstUserLabel?: string;
  children: React.ReactNode | Array<React.ReactNode>;
  ariaLabel?: string;
  isTabbable?: boolean;
};

type State = {
  tooltip: boolean;
  isModalOpen: boolean;
};

class OtherUsersComp extends React.Component<Props, State> {
  static displayName = 'OtherUsersComp';

  constructor(props: Props) {
    super(props);

    this.state = {
      tooltip: false,
      isModalOpen: false,
    };
  }

  showTooltip = () => {
    if (this.props.getData) {
      this.props.getData();
    }
    this.setState({ tooltip: true });
  };

  hideTooltip = () => {
    this.setState({ tooltip: false });
  };

  handleModal = () => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
      tooltip: false,
    });
  };

  getTooltipUsers = ():
    | Array<React.ReactElement<any>>
    | React.ReactElement<any> => {
    const { users, visibleUsers = 0, visibleInTooltip = 5 } = this.props;
    const total = users.length;
    const shownUsers = visibleUsers + visibleInTooltip;
    const list: Array<React.ReactElement<any>> = users
      .slice(visibleUsers, shownUsers)
      .map((user, i) => (
        <li key={i}>{`${user['first_name']} ${user['last_name']}`}</li>
      ));

    const hiddenUsers = total - shownUsers;

    if (hiddenUsers > 0) {
      return list.concat(
        <li key={total + 1}>
          {`& ${polyglot.t('feed.post.others', {
            smart_count: hiddenUsers,
          })}`}
        </li>,
      );
    }

    return <ul>{list}</ul>;
  };

  render() {
    const {
      users,
      hideTooltip,
      modalHeader,
      children,
      tooltipPosition,
      getUserLink,
      textStyle,
      hookStyle,
      hookClassName,
      ariaLabel,
      isTabbable = true,
    } = this.props;
    const { isModalOpen } = this.state;
    const haveData = !!users.length;

    return (
      <button
        className={styles.wrapper}
        onMouseEnter={this.showTooltip}
        onMouseDown={e => e.preventDefault()}
        onMouseLeave={this.hideTooltip}
        onFocus={this.showTooltip}
        onBlur={this.hideTooltip}
        onClick={this.handleModal}
        aria-label={ariaLabel}
        aria-hidden={isTabbable === false ? true : false}
        tabIndex={isTabbable ? 0 : -1}
      >
        {!hideTooltip ? (
          <TooltipComp
            position={tooltipPosition}
            textStyle={textStyle}
            hookStyle={hookStyle}
            hookClassName={hookClassName}
            showTooltip={this.state.tooltip && haveData}
            content={this.getTooltipUsers()}
          >
            {children}
          </TooltipComp>
        ) : (
          children
        )}
        {isModalOpen && (
          <ModalPortalComp
            isOpen={isModalOpen && haveData}
            onRequestClose={this.handleModal}
            showCloseButton={true}
            shouldCloseOnEsc={true}
            shouldCloseOnOuterClick={true}
          >
            <UsersModal
              modalHeader={modalHeader}
              users={users}
              getUserLink={getUserLink}
              onClose={this.handleModal}
              firstUserLabel={this.props.firstUserLabel}
            />
          </ModalPortalComp>
        )}
      </button>
    );
  }
}

export default OtherUsersComp;
